import { useTour } from '@reactour/tour';
import { isEmpty } from 'lodash';
import T from 'prop-types';
import React, { useMemo } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { TOUR_MODAL_START_CONFIG } from '../../pages/dashboard/components/onboarding/tour';
import { hideModal, toggleRightMenuVisibility } from '../../redux/actions';
import { clearTourSelected, putTourStatus } from '../../redux/actions/tour';
import text from '../../text';
import { AMPLITUDE_EVENTS } from '../../constants/analytics';
import { amplitudeTrack } from '../../utilities';
export var TOUR_DONE_MODAL = 'TOUR_DONE_MODAL';
var SITE_TOUR_ACTIVITY = AMPLITUDE_EVENTS.SITE_TOUR_ACTIVITY;
export default function TourDoneModal(param) {
    var show = param.show;
    var dispatch = useDispatch();
    var _useTour = useTour(), setSteps = _useTour.setSteps, setIsOpen = _useTour.setIsOpen;
    var tourSelected = useSelector(function(state) {
        return state.tourReducer.tourSelected;
    });
    var handleHide = function() {
        amplitudeTrack(SITE_TOUR_ACTIVITY.EVENT, {
            action: SITE_TOUR_ACTIVITY[tourSelected]['COMPLETED']
        });
        dispatch(putTourStatus(tourSelected));
        dispatch(hideModal(TOUR_DONE_MODAL));
        dispatch(toggleRightMenuVisibility(false));
        dispatch(clearTourSelected());
        setSteps([]);
        setIsOpen(false);
    };
    var MODAL_CONFIG = useMemo(function() {
        return TOUR_MODAL_START_CONFIG[tourSelected];
    }, [
        tourSelected
    ]);
    return !isEmpty(MODAL_CONFIG) && /*#__PURE__*/ React.createElement(Modal, {
        centered: true,
        className: "TourDoneModal",
        onHide: handleHide,
        show: show,
        backdrop: "static"
    }, /*#__PURE__*/ React.createElement(Modal.Header, {
        className: "centered",
        closeButton: true
    }, /*#__PURE__*/ React.createElement("img", {
        style: {
            height: '149px',
            width: '149px'
        },
        src: "/public/img/Congratulations.gif",
        alt: "Image not found"
    })), /*#__PURE__*/ React.createElement(Modal.Body, {
        className: "centered"
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "green-1"
    }, text('congratulations'), "!"), /*#__PURE__*/ React.createElement("p", {
        className: "mt-2 mb-0",
        style: {
            fontSize: 16
        }
    }, MODAL_CONFIG.done)), /*#__PURE__*/ React.createElement(Modal.Footer, {
        className: "flex-column justify-content-center"
    }, /*#__PURE__*/ React.createElement(Button, {
        onClick: handleHide
    }, text('letsPlay'))));
}
TourDoneModal.propTypes = {
    show: T.bool
};
